import PropTypes from 'prop-types'
import Styles from './UserChip.module.css'
import IFText from 'Components/IFText/IFText'
import { Colors } from 'Theme'
import { Chip } from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { styled as muiStyled } from '@mui/system'

const UserChip = ({ name, chargingTokensCount, onDelete }) => {
  const StyledChip = muiStyled(Chip)(({ theme }) => ({
    margin: theme.spacing(0.5),
    backgroundColor: Colors.FilterBackground,
    fontSize: '0.875rem',
    '&:hover': {
      backgroundColor: Colors.primary,
      color: 'white !important',
      '& .smallChip': {
        backgroundColor: 'white',
        color: Colors.primary,
      },
      '& .tokensCount': {
        color: Colors.primary,
      },
      '& .closeIcon': {
        color: Colors.white,
      },
    },
  }))

  return (
    <div className={Styles.Container}>
      <StyledChip
        deleteIcon={
          <CloseIcon
            style={{
              backgroundColor: Colors.primary,
            }}
            className={Styles.CloseIcon}
          />
        }
        label={
          <div className={Styles.Label}>
            <IFText className={Styles.Name}>{name}</IFText>

            {chargingTokensCount && (
              <div
                style={{
                  backgroundColor: Colors.primary,
                }}
                className={Styles.CloseIcon}
              >
                <IFText
                  style={{
                    color: Colors.white,
                  }}
                  className={Styles.Text}
                >
                  {chargingTokensCount}
                </IFText>
              </div>
            )}
          </div>
        }
        size="small"
        onDelete={onDelete}
      />
    </div>
  )
}

UserChip.propTypes = {
  name: PropTypes.string,
  imageURL: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isRound: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
}

export default UserChip
